angular.module('impactx.subsequentpurchaseorderdata').controller('EditSPOCtrl', [
    '$scope',
    '$mdDialog',
    'dataGen',
    'TranslationService',
    'ToastService',
    'themeFactory',
    'SubsequentPurchaseOrderDataService',
    EditSPOCtrl
]);

function EditSPOCtrl($scope, $mdDialog, dataGen, TranslationService, ToastService, themeFactory, SubsequentPurchaseOrderDataService) {

    const self = this;
    $scope.theme = themeFactory.getTheme();
    $scope.abortLabel = TranslationService.get("abort");
    $scope.saveLabel = TranslationService.get("save");
    $scope.deleteLabel = TranslationService.get("delete");
    self.maxDate = new Date();
    $scope.showdelete = 'bks' === self.type;

    function getData() {
        var params = {id: self.id};
        if ('bks' === self.type){
            params.reportOGD = self.reportOGD;
            params.hasSPOEnabled = self.hasSPOEnabled;
        };
        dataGen.getData($scope, params, "/editspo/"+self.type).then(function () {
            SubsequentPurchaseOrderDataService.initWatch($scope);
            $scope.trns.required = TranslationService.get("required");
            $scope.trns.enterDate = TranslationService.get("enterDate");
            $scope.trns.noSelectedItemMessage = TranslationService.get("noSelectedItemMessage");
        }, function () {
            $mdDialog.cancel();
        });
    }


    self.apply = function () {
        var data = {
            id: self.id,
            data: $scope.data
        };
        if ('bks' === self.type){
            data.hasSPOEnabled = self.hasSPOEnabled;
        };
        dataGen.postAsForm({}, data, "/editspo/"+self.type+"/save").then(function (response) {
            $mdDialog.hide(response);
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    };

    self.cancel = function () {
        $mdDialog.cancel();
    };

    self.delete = function () {
        dataGen.postAsForm($scope, {id: self.id}, "/editspo/bks/delete").then(function (response) {
            $mdDialog.hide(response);
            ToastService.openStandardToast(TranslationService.get("deleteSuccess"));
        });
    };

    self.addChangeListener = function() {
        $scope.$watch("data.tttPopup.selected", function() {
            if ($scope.data.tttPopup.selected && $scope.data.tttCompetitionIds.includes($scope.data.tttPopup.selected.id)) {
                $scope.data.withCompetition.readOnly = false;
            } else {
                $scope.data.withCompetition.value = true;
                $scope.data.withCompetition.readOnly = true;
            }
        });
    };

    self.updateMainProcurementGroup = function (selectedSPG) {
        if (impactX.isDefined($scope.data, 'mpgPopup') && impactX.isDefined(selectedSPG, 'id') &&
            (!$scope.data.mpgPopup.selected || !$scope.data.mpgPopup.selected.id)) {
            if (!selectedSPG.parent || !selectedSPG.parent.id || selectedSPG.parent.id === 0) {
                $scope.data.mpgPopup.selected = undefined;
            }
            else {
                $scope.data.mpgPopup.selected = selectedSPG.parent;
            }
        }
    };

    self.updateSecondProcurementGroups = function (selectedMPG) {
        if (impactX.isDefined($scope.data, 'spgPopup')
            && selectedMPG && selectedMPG.id && selectedMPG.id > 0
            && $scope.data.spgPopup.selected && $scope.data.spgPopup.selected.id && $scope.data.spgPopup.selected.id > 0
            && (!$scope.data.spgPopup.selected.parent || !$scope.data.spgPopup.selected.parent.id || $scope.data.spgPopup.selected.parent.id !== selectedMPG.id)) {
                $scope.data.spgPopup.selected = undefined;
        }
    };

    self.updateProcessProcessResult = function (selectedTTT) {
        if (impactX.isDefined($scope.data, "processResultPopup")) {
            dataGen.postAsForm({}, {tttId: selectedTTT ? selectedTTT.id : undefined, id: self.id}, "/editspo/"+self.type+"/ttt/change").then(function (response) {
                $scope.data.processResultPopup = response.data;
            });
        }
    };

    $scope.showGroup = Array(4).fill(true);
    self.toggleGroup = function (groupIndex) {
        $scope.showGroup[groupIndex] = !$scope.showGroup[groupIndex];
    };
    self.notEmptyGroup = function (groupIndex) {
        return document.getElementById('showGroup' + groupIndex).children.length > 0;
    };

    getData();

}
